export default __webpack_public_path__ + "static/media/24.2e6b8b7d.jpg";